import { jsx } from 'react/jsx-runtime';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { useState } from 'react';
import { SelectSearchProvider } from '../context.mjs';

const SelectSearchRoot = ({
  children,
  defaultValue,
  value: valueFromProps,
  onChangeValue
}) => {
  const [value = "", setValue] = useControllableState({
    prop: valueFromProps,
    defaultProp: defaultValue,
    onChange: onChangeValue
  });
  const [renderEmpty, setRenderEmpty] = useState(false);
  return /* @__PURE__ */ jsx(
    SelectSearchProvider,
    {
      searchValue: value,
      onSearchValueChange: setValue,
      renderEmpty,
      onRenderEmptyChange: setRenderEmpty,
      children
    }
  );
};

export { SelectSearchRoot };
//# sourceMappingURL=search-root.mjs.map
